import type { TodoFolderDescriptor } from '../schema/TodoFolderDescriptor';
import type { TodoMyDayDescriptor } from '../schema/TodoMyDayDescriptor';
import type { TodoDueDateDescriptor } from '../schema/TodoDueDateDescriptor';
import { TodoDescriptorType } from '../schema/TodoDescriptorType';
import type { TodoDescriptor } from '../schema/TodoDescriptor';

export function isTodoFolderDescriptor(
    descriptor: TodoDescriptor
): descriptor is TodoFolderDescriptor {
    return descriptor && descriptor.type === TodoDescriptorType.FolderId;
}
export function isTodoMyDayDescriptor(
    descriptor: TodoDescriptor
): descriptor is TodoMyDayDescriptor {
    return descriptor && descriptor.type === TodoDescriptorType.MyDay;
}

export function isTodoDueDateDescriptor(
    descriptor: TodoDescriptor
): descriptor is TodoDueDateDescriptor {
    return descriptor && descriptor.type === TodoDescriptorType.DueDate;
}
